import { css } from '@styles/theme'

export const DashboardStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',
		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	listCardsStats: css({
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: '22px 26px',
		py: '32px',
		'@md': {
			gap: '34px',
		},
		'@resp': {
			gridTemplateColumns: 'repeat(5, minmax(185px, 100%))',
		},
	}),
	listCharts: css({
		display: 'flex',
		gap: '44px',
		marginTop: '32px',
		marginBottom: '32px',
		flexDirection: 'column',
		'@md': {
			flexDirection: 'row',
		},
	}),
	containerClear: css({
		display: 'flex',
		gap: '44px',
		marginTop: '54px',
		marginBottom: '62px',
		justifyContent: 'flex-end',
		button: {
			_font: 'normal',
			fontWeight: 400,
			fontSize: '16px',
			lineHeight: '18px',
			letterSpacing: '0.04em',
			textDecorationLine: 'underline',
			color: '$orange40',
			cursor: 'pointer',
		},
	}),
	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '40px',
		flexDirection: 'column',
		gap: '10px',
		'@sm': {
			flexDirection: 'row',
			justifyContent: 'space-between',
		},
	}),
	buttons: css({
		display: 'grid',
		gridTemplateColumns: '180px 1fr',
		gridTemplateAreas: `
		'filter filter'
		'clear refresh'
	  `,
		justifyItems: 'end',
		gap: '16px',
		'@md': {
			display: 'flex',
			width: '100%',
			maxWidth: '574px',
			gap: '24px',
			justifyContent: 'flex-end',
		},
	}),

	filterSideMenu: css({
		display: 'flex',
		padding: '32px',
		flexDirection: 'column',
		gap: '32px',
	}),

	tagsSideMenu: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '21px',
		padding: '32px 0px;',
		margin: '0px 32px',
		maxHeight: 'calc(80vh - 120px)',
		borderTop: '1px solid $neutral50',
	}),

	buttonSideMenu: css({
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		padding: '32px',
		gap: '32px',
	}),

	deleteHistoryContainer: css({
		display: 'flex',
		flexDirection: 'column',
	}),

	deleteHistoryImage: css({
		width: '100px',
		margin: 'auto',
		'@sm': {
			width: '188px',
		},
	}),

	deleteHistoryTitle: css({
		marginTop: '16px',
		fontSize: '18px',
		textAlign: 'center',
		fontFamily: 'Roboto',
		'@sm': {
			lineHeight: '20px',
			marginTop: '20px',
			fontSize: '24px',
		},
	}),

	deleteHistoryParaghaph: css({
		fontSize: '16px',
		letterSpacing: '5%',
		lineHeight: '20px',
		'@sm': {
			fontSize: '18px',
			fontWeight: '500',
			letterSpacing: '5%',
			lineHeight: '25px',
		},
	}),

	deleteHistoryInputText: css({
		border: '1px solid #C4C4C4',
		borderRadius: '12px',
		height: '40px',
		width: '100%',
		marginTop: '16px',
		padding: '10px 8px',
		fontSize: '12px',
		'@sm': {
			height: '48px',
			marginTop: '20px',
			padding: '20px 16px 20px 16px',
			fontSize: '16px',
			letterSpacing: '5%',
		},
	}),

	deleteHistoryButton: css({
		padding: '14px 16px',
		borderRadius: '14px',
		backgroundColor: 'red',
		textAlign: 'center',
		width: '100%',
		color: 'white',
		transition: 'all 0.3s',
		cursor: 'pointer',
		height: '40px',
		fontSize: '12px',
		font: 'normal',
		'@sm': {
			height: '48px',
			fontSize: '18px',
		},
		'&:disabled': {
			backgroundColor: 'lightgray',
		},
	}),

	popupContainer: css({
		top: '50%',
		left: '50%',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.8)',
		padding: '0px',
		height: 'auto',
		width: 'min-content',
		minWidth: '40vh',
		minHeight: '40vh',
		'@lg': {
			minWidth: '50vh',
			minHeight: '50vh',
		},
		'@resp': {
			minWidth: '80vh',
			minHeight: '80vh',
		},
	}),

	popupImage: css({
		width: 'auto',
		height: 'auto',
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
	}),
}
